import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Actions} from '../../../common/actions';
import ProviderForm from './form';
import './editProvider.scss';

class EditProvider extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }

  async onSubmit(formValues) {
    const {selectedProvider} = this.props;
    return await this.props.editProvider(selectedProvider.code, formValues);
  }

  render() {
    const {selectedProvider, goBack, push} = this.props;
    const {pathname} = this.props.history.location;
    return (
      <ProviderForm
        goBack={goBack}
        push={push}
        selectedProvider={selectedProvider}
        onSubmit={this.onSubmit}
        viewMode={pathname.includes('ver')}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {code} = ownProps.params;
  const selectedProvider = state.provider.list.find(
    (item) => item.code === code
  );
  return {
    selectedProvider,
    'goBack': ownProps.history.goBack,
    'push': ownProps.history.push,
  };
};

const {editProvider, withRouter} = Actions;

export default withRouter(
  connect(mapStateToProps, {
    editProvider,
  })(EditProvider)
);
